// removed by extract-text-webpack-plugin
module.exports = {"link-creating-sales-type":"app-pages-Library-SalesType-__SalesType___D2IlI"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/SalesType/SalesType.css
// module id = 2457
// module chunks = 0